import { Enum } from 'enumify-mod';

class GenderOptions extends Enum {
	static MR;
	static MRS;
}

GenderOptions.initEnum({
	MR: 'Mr',
	MRS: 'Mrs'
});

/**
 * @return {SelectOption[]}
 */
GenderOptions.toOptions = () => [
	{ value: GenderOptions.MR.value, label: 'Mr.', selected: false },
	{ value: GenderOptions.MRS.value, label: 'Mrs.', selected: false }
];

export default GenderOptions;


// WEBPACK FOOTER //
// ./enums/GenderOptions.js